import React from 'react'
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import {  Button, Card, Flex, Spinner, TextField, Text } from '@radix-ui/themes';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { createPaymentMethod } from '../../../services/finance/paymentMethods';
import { PaymentMethodType } from '../../../types/Finance';
import { CreatePaymentMethodFormValidation } from './CreatePaymentMethodFormValidation';
import { routes } from '../../../routes';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
export const CreatePaymentMethod= ()=> {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createPaymentMethod, mutationKey: 'createPaymentMethod' });
  const { control, handleSubmit, formState: { errors } } = useForm<PaymentMethodType>
    (
      {
        resolver: yupResolver(CreatePaymentMethodFormValidation),
        defaultValues: {
          description: ''
        },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Criado!");
        navigate(routes.paymentMethods);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    navigate(routes.paymentMethods);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
            <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}